<template>
  <!-- Footer -->
  <div class="navbar navbar-sm navbar-footer border-top">
    <div class="container-fluid">
      <span>
        &copy; 
        {{ currentYear }}
        <a href="https://yilport.com/" target="_blank">YILPORT HOLDING - CProX</a>
        <span class="text-muted">
          V  {{ appVersion }}
        </span>
      </span>

      <ul class="nav">
        <li class="nav-item">
          <div class="p-1">
            <LanguageButtonComp></LanguageButtonComp>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <!-- /footer -->
</template>
<script>
import LanguageButtonComp from "@/CommonVueCore/src/components/baseComponents/LanguageButtonComp.vue";

export default {
  components: {
    LanguageButtonComp,
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
    appVersion() {
      return localStorage.getItem("appVersion");
    },
  },
};
</script>
<style scoped>

.page-size-is-mobile .container-fluid {
  justify-content: center;
}

</style>
